module.exports = __webpack_public_path__ + "c04db2de90f52e54c903213a5e1d1190.png";